import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { TutorialServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Organisation States Master section
 */
const useListTutorial = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["tutorial-list", page_no], TutorialServices.tutorialList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddTutorial = (onSuccess, onError = onDefaultError) => {
  return useMutation(TutorialServices.addTutorial, {
    onSuccess,
    onError,
  });
};
const useUpdateTutorial = (onSuccess, onError = onDefaultError) => {
  return useMutation(TutorialServices.updateTutorial, {
    onSuccess,
    onError,
  });
};
const useViewTutorial = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(
    "tutorial-view",
    () => TutorialServices.viewTutorial({ id }),
    {
      onSuccess,
      onError,
    }
  );
};
const useTutorialDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(TutorialServices.deleteTutorial, {
    onSuccess,
    onError,
  });
};
const useGetProductList = (onSuccess, onError = onDefaultError) => {
  return useQuery("product-list", TutorialServices.getProductList, {
    onSuccess,
    onError,
  });
};
export {
  useListTutorial,
  useUpdateTutorial,
  useViewTutorial,
  useAddTutorial,
  useTutorialDelete,
  useGetProductList,
};
